import React from 'react';
import { reduxForm } from 'redux-form';
import PropTypes from 'prop-types';
import { translate } from 'react-polyglot';
import { FormInput, FormLabel, FormFeedback } from './form';
import { Button } from './buttons';
import './Invite.css';

function Invite(props) {
  const {
    isSuccessMessageVisible,
    isEmailDuplicateMessageVisible,
    isResearchIdDuplicateMessageVisible,
    isLoading,
    isButtonDisabled,
    handleSubmit,
    t
  } = props;

  const title = isSuccessMessageVisible
    ? t('invite.successTitle')
    : t('invite.title');

  return (
    <div>
      <div className="page-header">
        <h3>{title}</h3>
      </div>
      <div className="invite-container container">
        {isSuccessMessageVisible ? (
          <div className="invite-success-message">
            <p>{t('invite.successDescription1')}</p>
            <p>{t('invite.successDescription2')}</p>
          </div>
        ) : (
          <form className="invite" onSubmit={handleSubmit}>
            <p>{t('invite.description')}</p>
            <FormInput
              required
              disabled={isLoading}
              reject={isEmailDuplicateMessageVisible}
              labelRenderer={() => (
                <FormLabel>{t('invite.emailLabel')}</FormLabel>
              )}
              id="invite.email"
              name="email"
              placeholder={props.t('invite.emailPlaceholder')}
              type="email"
            />
            {isEmailDuplicateMessageVisible && (
              <FormFeedback positive={false}>
                {t('invite.duplicateEmail')}
              </FormFeedback>
            )}
            <FormInput
              required
              disabled={isLoading}
              reject={isResearchIdDuplicateMessageVisible}
              labelRenderer={() => (
                <FormLabel>{t('invite.researchIdLabel')}</FormLabel>
              )}
              id="invite.researchId"
              name="researchId"
              placeholder={props.t('invite.researchIdPlaceholder')}
            />
            {isResearchIdDuplicateMessageVisible && (
              <FormFeedback positive={false}>
                {t('invite.duplicateResearchId')}
              </FormFeedback>
            )}
            <div className="invite-container__footer">
              <Button
                colorScheme="red"
                label={t('invite.button')}
                loading={isLoading}
                disabled={isButtonDisabled || isLoading}
                type="submit"
              />
            </div>
          </form>
        )}
      </div>
    </div>
  );
}

Invite.propTypes = {
  isEmailDuplicateMessageVisible: PropTypes.bool.isRequired,
  isResearchIdDuplicateMessageVisible: PropTypes.bool.isRequired,
  isSuccessMessageVisible: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
  isButtonDisabled: PropTypes.bool.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired
};

const createReduxForm = reduxForm({
  form: 'invite'
});

export default createReduxForm(translate()(Invite));



// WEBPACK FOOTER //
// ./src/components/Invite.js